import { makeStyles } from '@material-ui/core/styles';
import { modalPaperStyle } from '../../../shared/components/RedesignModal/RedesignModal.styles';
import { redesignTheme } from '../../../theme';

const { spacing, breakpoints, sizes, colors, fonts, fontSize, radius } = redesignTheme;

export const useRecrutementModalStyles = makeStyles(() => ({
  modal: {
    ...modalPaperStyle,
    maxWidth: sizes.modalMaxWidth,
    maxHeight: '90vh',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      maxHeight: '95vh',
      padding: spacing.sm,
    },
  },
  headerBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
    width: '100%',
  },
  modalHeading: {
    margin: 0,
    flex: 1,
    minWidth: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    letterSpacing: 0.4,
    lineHeight: 1.4,
  },
  closeButton: {
    flexShrink: 0,
    margin: -4,
    padding: 4,
    color: colors.primaryDark,
    '&:hover': {
      backgroundColor: colors.progressTrack,
    },
  },
  secondaryAction: {
    flexShrink: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    padding: '4px 8px',
    '&:hover': {
      opacity: 0.8,
    },
  },
  modalDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    lineHeight: 1.5,
  },
  modalCaption: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: radius.sm,
    border: `1px solid ${colors.dangerBorderLight}`,
    backgroundColor: colors.dangerIconSurface,
    color: colors.dangerText,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 1.5,
    boxSizing: 'border-box',
  },
  errorMessage: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.dangerText,
  },
  loadingWrap: {
    display: 'flex',
    justifyContent: 'center',
    padding: `${spacing.md}px 0`,
  },
}));
